export function ImagePlusIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_333_1576)">
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <circle cx="10" cy="10" r="9.7" stroke="black" stroke-opacity="0.1" stroke-width="0.6" />
        <path d="M9.99985 6.50113V13.5011M6.49985 10.0011H13.4998" stroke="#475467" stroke-width="1.002" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_333_1576">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

ImagePlusIcon.displayName = 'ImagePlusIcon';
